/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PipelineTypeEnum } from './PipelineTypeEnum';
import {
    PipelineTypeEnumFromJSON,
    PipelineTypeEnumFromJSONTyped,
    PipelineTypeEnumToJSON,
    PipelineTypeEnumToJSONTyped,
} from './PipelineTypeEnum';
import type { PipelineProductEnum } from './PipelineProductEnum';
import {
    PipelineProductEnumFromJSON,
    PipelineProductEnumFromJSONTyped,
    PipelineProductEnumToJSON,
    PipelineProductEnumToJSONTyped,
} from './PipelineProductEnum';

/**
 * Full Pipeline serializer, used to display table and
 * detailed infrastructure information.
 * @export
 * @interface Pipeline
 */
export interface Pipeline {
    /**
     * 
     * @type {string}
     * @memberof Pipeline
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Pipeline
     */
    readonly ownerName: string;
    /**
     * 
     * @type {string}
     * @memberof Pipeline
     */
    lineId: string;
    /**
     * 
     * @type {PipelineProductEnum}
     * @memberof Pipeline
     */
    pipelineProduct: PipelineProductEnum;
    /**
     * 
     * @type {PipelineTypeEnum}
     * @memberof Pipeline
     */
    pipelineType: PipelineTypeEnum;
}



/**
 * Check if a given object implements the Pipeline interface.
 */
export function instanceOfPipeline(value: object): value is Pipeline {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('ownerName' in (value as Record<string, any>)) && !('owner_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['ownerName'] === undefined && (value as Record<string, any>)['owner_name'] === undefined)) return false;
    if ((!('lineId' in (value as Record<string, any>)) && !('line_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['lineId'] === undefined && (value as Record<string, any>)['line_id'] === undefined)) return false;
    if ((!('pipelineProduct' in (value as Record<string, any>)) && !('pipeline_product' in (value as Record<string, any>))) || ((value as Record<string, any>)['pipelineProduct'] === undefined && (value as Record<string, any>)['pipeline_product'] === undefined)) return false;
    if ((!('pipelineType' in (value as Record<string, any>)) && !('pipeline_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['pipelineType'] === undefined && (value as Record<string, any>)['pipeline_type'] === undefined)) return false;
    return true;
}

export function PipelineFromJSON(json: any): Pipeline {
    return PipelineFromJSONTyped(json, false);
}

export function PipelineFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pipeline {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ownerName': json['owner_name'],
        'lineId': json['line_id'],
        'pipelineProduct': PipelineProductEnumFromJSON(json['pipeline_product']),
        'pipelineType': PipelineTypeEnumFromJSON(json['pipeline_type']),
    };
}

export function PipelineToJSON(json: any): Pipeline {
    return PipelineToJSONTyped(json, false);
}

export function PipelineToJSONTyped(value?: Omit<Pipeline, 'id'|'ownerName'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line_id': value['lineId'],
        'pipeline_product': PipelineProductEnumToJSON(value['pipelineProduct']),
        'pipeline_type': PipelineTypeEnumToJSON(value['pipelineType']),
    };
}

